import React, { useState, useEffect } from "react";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/database";
import { Context } from "../backend/context";

import { tradingSetupsData } from "../backend/tradingSetupData";

import { Link, withRouter } from "react-router-dom";
import { Redirect } from "react-router";
import { connect } from "react-redux";

function CreateBotBeginner(props) {
  const {
    uid,
    isLoggedIn,
    user,
    api_key,
    alert,
    isRestricted,
    binance_api_key,
  } = React.useContext(Context);

  const [tradingSetup, setTradingSetup] = useState("7");
  const [market, setMarket] = useState("btc_usdc");
  const [setupData, setSetupData] = useState(tradingSetupsData[0]);

  const [submitType, setSubmitType] = useState("start");
  const [name, setName] = useState("");
  const [fbDailyVolume, setFBDailyVolume] = useState(0);
  const [fbTakerVolume, setFBTakerVolume] = useState(0);
  const [fbProfit, setFBProfit] = useState(0);
  const [isVolumeFeedbackCorrect, setVolumeFeedbackState] = useState(true);
  const [isVolumeFeedbackSubmited, setVolumeFeedbackSubmitState] = useState(
    false
  );
  const [isProfitFeedbackCorrect, setProfitFeedbackState] = useState(true);
  const [isProfitFeedbackSubmited, setProfitFeedbackSubmitState] = useState(
    false
  );

  useEffect(() => {
    setVolumeFeedbackState(true);
    setVolumeFeedbackSubmitState(false);
    setProfitFeedbackState(true);
    setProfitFeedbackSubmitState(false);
    setFBDailyVolume(0);
    setFBProfit(0);
    setFBTakerVolume(0);
    tradingSetupsData.forEach((element) => {
      if (
        element.id === tradingSetup &&
        (element.market === "fixed" || element.market === market)
      ) {
        setSetupData(element);
        return;
      }
    });
  }, [market, tradingSetup]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (submitType === "start" && !isRestricted) {
      var i = 0;
      setupData.bots.forEach((element) => {
        firebase
          .firestore()
          .collection("pendingBots")
          .add({
            ...element,
            name: name + " " + i++,
            createdAt: Date.now(),
            displayId: (props.botsCount + 100000 + i).toString(),
            uid: uid,
          })
          .then((ref) => {
            var botsCountRef = firebase.database().ref("botsCount").push();

            botsCountRef.set({
              displayId: (props.botsCount + 100000 + i).toString(),
            });
          })
          .catch((err) => {
            console.log(err);
          });
      });
    } else {
      var j = 0;
      setupData.bots.forEach((element) => {
        firebase
          .firestore()
          .collection("bots")
          .add({
            ...element,
            name: name + " " + j++,
            createdAt: Date.now(),
            displayId: (props.botsCount + 100000 + j).toString(),
            uid: uid,
          })
          .then((ref) => {
            // console.log("New Bot successfully saved");
            var botsCountRef = firebase.database().ref("botsCount").push();

            botsCountRef.set({
              displayId: (props.botsCount + 100000).toString(),
            });
          })
          .catch((err) => {
            console.log(err);
          });
      });
    }

    props.history.push("/account");
  };

  var handleVolumeFeedback = (isCorrect) => {
    firebase
      .database()
      .ref("tradingSetupFeedback/volume")
      .push({
        setupID: setupData.id,
        market: setupData.market,
        uid: uid,
        createdAt: Date.now(),
        isCorrect: isCorrect,
        data: {
          dailyVolume: fbDailyVolume,
          takerVolume: fbTakerVolume,
        },
      });
    setVolumeFeedbackSubmitState(true);
  };
  var handleProfitFeedback = (isCorrect) => {
    firebase
      .database()
      .ref("tradingSetupFeedback/profit")
      .push({
        setupID: setupData.id,
        market: setupData.market,
        uid: uid,
        createdAt: Date.now(),
        isCorrect: isCorrect,
        data: {
          profit: fbProfit,
        },
      });
    setProfitFeedbackSubmitState(true);
  };

  return (
    <div className="py-5 container text-left badge-dark">
      {!isLoggedIn || !user ? <Redirect to="/" /> : null}
      {api_key.length < 5 ? <Redirect to="/account" /> : null}
      {alert.isAvailable && (
        <div className="row">
          <div
            className={"col-11 m-auto text-center alert alert-" + alert.type}
          >
            {alert.msg}
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-12 h3 pt-3 text-center">
          Create New Bot - Beginner
        </div>
      </div>
      {binance_api_key.length < 1 &&
        (tradingSetup === "2" || tradingSetup === "5") && (
          <div className="form-group row">
            <div className="col-10 alert alert-warning text-center m-auto">
              BINANCE API KEY NOT FOUND ! Please add your Binance API KEY.
              <Link to="/account/settings"> Go To Settings</Link>
            </div>{" "}
          </div>
        )}
      <div className="row">
        <div className="col-11 col-sm-8 m-auto ">
          <form onSubmit={handleSubmit}>
            <div className="form-group row mt-3 ">
              <label className="col-6 col-form-label">Name</label>
              <div className="col-6">
                <input
                  required
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  type="text"
                  className="form-control"
                  value={name}
                />
              </div>
            </div>
            <div className="form-group row mt-3 ">
              <label className="col-6 col-form-label tooltipMy">
                Trading Setup
              </label>
              <div className="col-6">
                <select
                  required
                  onChange={(e) => {
                    setTradingSetup(e.target.value);
                  }}
                  className="custom-select mr-sm-2"
                  defaultValue="7"
                >
                  <option value="7">DCA BUY</option>
                  <option value="8">NEO-USDC BUY DCA</option>
                  <option value="9">NEO-USDC SELL DCA</option>
                  <option value="10">NEO-USDC Market-Maker</option>
                  <option value="1">Maker/Taker Volume</option>
                  <option value="6">Maker Profit</option>
                  <option value="2">Binance Arbitrage Volume</option>
                  <option value="5">Binance Arbitrage Profit</option>
                  <option value="4">Noia Maker/Taker Volume </option>
                </select>
              </div>
            </div>
            {tradingSetup === "1" && (
              <div className="form-group row">
                <label className="col-6 col-form-label">Market</label>
                <div className="col-6">
                  <select
                    required
                    onChange={(e) => {
                      setMarket(e.target.value);
                    }}
                    className="custom-select mr-sm-2"
                    defaultValue="btc_usdc"
                  >
                    <option value="btc_usdc">BTC/USDC</option>
                    <option value="eth_usdc">ETH/USDC</option>
                  </select>
                </div>
              </div>
            )}
            <div className="form-group row mt-5">
              <div className="col-12 border border-black rounded-lg pt-4 componentWrapper">
                <div className="header">Description</div>
                <div className="form-group row">
                  <div className="col-12">
                    This setup will create total{" "}
                    {setupData.displayData.totalBots} bots. <br />
                    {setupData.displayData.bots.map((item, key) => {
                      return (
                        <span key={key} className="pl-5">
                          {item.count} - {item.market} {item.type} <br />
                        </span>
                      );
                    })}
                    {setupData.displayData.description}
                  </div>
                </div>
              </div>
            </div>{" "}
            <div className="form-group row">
              <div className="col-12 border border-black rounded-lg pt-4 componentWrapper">
                <div className="header">Trading Capital</div>
                <div className="form-group row">
                  <div className="col-12">
                    Following assets need to available in your Nash trading
                    contract
                    {(tradingSetup === "2" || tradingSetup === "5") &&
                      " and Binance Margin account"}
                    . <br />
                    {setupData.displayData.assets.map((item, key) => {
                      return (
                        <span key={key} className="pl-5">
                          {item.amount}{" "}
                          {(tradingSetup === "2" || tradingSetup === "5") &&
                            "in " + item.exchange}{" "}
                          <br />
                        </span>
                      );
                    })}
                    {setupData.displayData.assetsNote.length > 0 && (
                      <span className="">
                        {" "}
                        <br />
                        {setupData.displayData.assetsNote}
                        <br />
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group row">
              <div className="col-12 border border-black rounded-lg pt-4 componentWrapper">
                <div className="header tooltipMy">
                  Estimate Volume{" "}
                  <div
                    className="tooltiptextmy p-3 text-center"
                    style={
                      isVolumeFeedbackCorrect || isVolumeFeedbackSubmited
                        ? { width: "15rem" }
                        : { width: "20rem" }
                    }
                  >
                    <span>
                      {isVolumeFeedbackSubmited ? (
                        <div className="row mt-2">
                          <div className="col-12 text-center">
                            Thank You for your Feedback..
                          </div>
                        </div>
                      ) : isVolumeFeedbackCorrect ? (
                        <div>
                          Is this estimated volume correct?
                          <div className="row mt-2">
                            <div className="col-6 text-center">
                              <button
                                type="button"
                                className="btn btn-success w-100 m-auto"
                                onClick={() => handleVolumeFeedback(true)}
                              >
                                Yes
                              </button>
                            </div>
                            <div className="col-6 text-center">
                              <button
                                type="button"
                                className="btn btn-danger w-100 m-auto"
                                onClick={() => setVolumeFeedbackState(false)}
                              >
                                No
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div>
                          What are your values?
                          <div className="form-group row mt-2">
                            <label className="col-6 col-form-label  text-left">
                              Daily Volume $
                            </label>
                            <div className="col-6 ">
                              <input
                                required
                                onChange={(e) => {
                                  setFBDailyVolume(e.target.value);
                                }}
                                type="number"
                                // step="50"
                                className="form-control"
                                min="0"
                                value={fbDailyVolume}
                                // max={maxOrderSize}
                              />
                            </div>
                          </div>
                          <div className="form-group row mt-2">
                            <label className="col-6 col-form-label text-left">
                              Taker Volume %
                            </label>
                            <div className="col-6 ">
                              <input
                                required
                                onChange={(e) => {
                                  setFBTakerVolume(e.target.value);
                                }}
                                type="number"
                                // step="50"
                                className="form-control"
                                min="0"
                                value={fbTakerVolume}
                                max="100"
                              />
                            </div>
                          </div>
                          <div className="form-group row mt-2">
                            <div className="col-6 text-center">
                              <button
                                type="button"
                                className="btn btn-secondary w-100 m-auto"
                                onClick={() => setVolumeFeedbackState(true)}
                              >
                                Back
                              </button>
                            </div>
                            <div className="col-6 text-center">
                              <button
                                type="button"
                                onClick={() => handleVolumeFeedback(false)}
                                className="btn btn-success w-100 m-auto"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-12 ">
                    {" "}
                    <span className="pl-5">
                      Average total daily volume ~ $
                      {setupData.displayData.totalVolume} <br />
                      <span className="mt-2 pl-5">
                        {" "}
                        Maker volume ~ {setupData.displayData.makerVolume}%
                        <br />
                      </span>{" "}
                      <span className=" pl-5">
                        Taker volume ~ {100 - setupData.displayData.makerVolume}
                        % <br />
                      </span>{" "}
                    </span>
                    {setupData.displayData.volumeNote.length > 0 && (
                      <span className="">
                        {" "}
                        <br />
                        {setupData.displayData.volumeNote}
                        <br />
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group row">
              <div className="col-12 border border-black rounded-lg pt-4 componentWrapper">
                <div className="header tooltipMy">
                  Estimate Profit / Loss{" "}
                  <div
                    className="tooltiptextmy p-3 text-center"
                    style={
                      isProfitFeedbackCorrect || isProfitFeedbackSubmited
                        ? { width: "15rem" }
                        : { width: "20rem" }
                    }
                  >
                    <span>
                      {isProfitFeedbackSubmited ? (
                        <div className="row mt-2">
                          <div className="col-12 text-center">
                            Thank You for your Feedback..
                          </div>
                        </div>
                      ) : isProfitFeedbackCorrect ? (
                        <div>
                          Is this estimated profit correct?
                          <div className="row mt-2">
                            <div className="col-6 text-center">
                              <button
                                type="button"
                                className="btn btn-success w-100 m-auto"
                                onClick={() => handleProfitFeedback(true)}
                              >
                                Yes
                              </button>
                            </div>
                            <div className="col-6 text-center">
                              <button
                                type="button"
                                className="btn btn-danger w-100 m-auto"
                                onClick={() => setProfitFeedbackState(false)}
                              >
                                No
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div>
                          What is your profit?
                          <div className="form-group row mt-2">
                            <label className="col-6 col-form-label text-left">
                              Profit %
                            </label>
                            <div className="col-6 ">
                              <input
                                required
                                onChange={(e) => {
                                  setFBProfit(e.target.value);
                                }}
                                type="number"
                                step="0.001"
                                className="form-control"
                                min="-100"
                                value={fbProfit}
                                max="100"
                              />
                            </div>
                          </div>
                          <div className="form-group row mt-2">
                            <div className="col-6 text-center">
                              <button
                                type="button"
                                className="btn btn-secondary w-100 m-auto"
                                onClick={() => setProfitFeedbackState(true)}
                              >
                                Back
                              </button>
                            </div>
                            <div className="col-6 text-center">
                              <button
                                type="button"
                                onClick={() => handleProfitFeedback(false)}
                                className="btn btn-success w-100 m-auto"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-12 ">
                    <span className="pl-5">
                      Average{" "}
                      {setupData.displayData.profit >= 0
                        ? "Profit ~ " + setupData.displayData.profit
                        : "Loss ~ " + -setupData.displayData.profit}
                      %<br />
                    </span>
                    {setupData.displayData.profitNote.length > 0 && (
                      <span className="">
                        {" "}
                        <br />
                        {setupData.displayData.profitNote}
                        <br />
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group row">
              <div className="col-12">
                **Estimate data have calculated using users feedbacks.
              </div>{" "}
            </div>
            <div className="form-group row">
              <div className="col-sm-8 m-auto col-12">
                <div className="row">
                  <div className="col-4 text-center verticalCenter">
                    <Link
                      to="/account/createbot"
                      // type="submit"
                      className="btn btn-secondary w-100"
                    >
                      Back
                    </Link>
                  </div>
                  <div className="col-4 text-center verticalCenter">
                    <button
                      className="btn btn-primary w-100"
                      disabled={
                        binance_api_key.length < 1 &&
                        (tradingSetup === "2" || tradingSetup === "5")
                      }
                      type="submit"
                      onClick={() => setSubmitType("save")}
                    >
                      Save
                    </button>
                  </div>
                  <div className="col-4 text-left">
                    <button
                      disabled={
                        isRestricted ||
                        (binance_api_key.length < 1 &&
                          (tradingSetup === "2" || tradingSetup === "5"))
                      }
                      onClick={() => setSubmitType("start")}
                      type="submit"
                      className="btn btn-success w-100"
                    >
                      Save & Start
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  botsCount: state.botsCount.botsCount,
});

export default withRouter(connect(mapStateToProps)(CreateBotBeginner));
